var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5016 3.32964C14.2971 3.54077 14.1822 3.8271 14.1822 4.12564C14.1822 4.42418 14.2971 4.7105 14.5016 4.92164L20.2758 10.8809L1.09092 10.8809C0.80159 10.8809 0.52411 10.9995 0.319523 11.2107C0.114936 11.4218 1.10804e-07 11.7082 1.07243e-07 12.0068C1.03682e-07 12.3054 0.114936 12.5918 0.319523 12.8029C0.52411 13.0141 0.80159 13.1327 1.09092 13.1327L20.2758 13.1327L14.5016 19.092C14.3029 19.3043 14.1929 19.5887 14.1954 19.8839C14.1979 20.1791 14.3126 20.4615 14.5149 20.6702C14.7172 20.879 14.9908 20.9974 15.2768 21C15.5628 21.0025 15.8384 20.889 16.0442 20.684L23.6806 12.8028C23.8851 12.5917 24 12.3053 24 12.0068C24 11.7083 23.8851 11.4219 23.6806 11.2108L16.0442 3.32964C15.8396 3.11857 15.5621 3 15.2729 3C14.9836 3 14.7062 3.11857 14.5016 3.32964Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rightArrow.0bf8736fac13ad5e760635de92711332.svg";